import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div>
      <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Icon name="Folder" size={20} />
        Categories
      </h3>
      <div className="space-y-2">
        {/* All Categories Option */}
        <button
          onClick={() => onCategoryChange(null)}
          className={`w-full text-left px-4 py-2 rounded-lg transition-all duration-200 ${
            selectedCategory === null
              ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-md'
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          <div className="flex items-center justify-between">
            <span className="font-medium">All Posts</span>
            {selectedCategory === null && (
              <Icon name="Check" size={16} />
            )}
          </div>
        </button>

        {/* Category Options — uses slug for Sanity, id for legacy */}
        {categories?.map((category) => {
          const categoryKey = category?.slug || category?.id;
          const categoryName = category?.title || category?.name;
          const isSelected = selectedCategory === categoryKey;

          return (
            <button
              key={category?._id || category?.id}
              onClick={() => onCategoryChange(categoryKey)}
              className={`w-full text-left px-4 py-2 rounded-lg transition-all duration-200 ${
                isSelected
                  ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-md'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium">{categoryName}</div>
                  {category?.description && (
                    <div className={`text-xs mt-1 ${
                      isSelected ? 'text-blue-100' : 'text-gray-500'
                    }`}>
                      {category?.description}
                    </div>
                  )}
                </div>
                {isSelected && (
                  <Icon name="Check" size={16} />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryFilter;